module.exports = __webpack_public_path__ + "img/User interface_Outline.3373a089.png";